import axios from "../axios";

export const setInitiatePayment = () => {
  sessionStorage.setItem("initiatePayment", true);
};

export function fetchBrowserInfo() {
  var browserInfo = {};
  browserInfo.appName = navigator.appName;
  browserInfo.appCodeName = navigator.appCodeName;
  browserInfo.cookieEnable = navigator.cookieEnabled;
  browserInfo.prodName = navigator.product;
  browserInfo.appVersion = navigator.appVersion;
  browserInfo.appOs = navigator.platform;
  browserInfo.appLang = navigator.language;
  browserInfo.vendorName = navigator.vendor;
  browserInfo.loginDomain = "auth";
  return browserInfo;
}

export async function handleCaptureClick(course_slug, click_type) {
  const formBody = { course_slug, click_type };
  await axios.put("crm/capture-click/", formBody);
}

export function formatNumberWithCommas(num) {
  if (num === null || num === undefined) return num;
  else {
    const formatter = new Intl.NumberFormat();
    return formatter.format(num);
  }
}

export const getUrlSearchParams = (url, paramsToSearch) => {
  const urlParams = new URLSearchParams(url);
  const result = {};

  paramsToSearch.forEach((param) => {
    result[param] = urlParams.get(param);
  });

  return result;
};
